import React, { useEffect, useState } from "react";
import Dropdown from "react-dropdown";
import CustomBtnComponent from "../btn/buttonCustom";
import axios from "../../Axios";
import DownArrow from "../assets/DownArrow";
import { useRouter } from "next/router";
import useToast from "../Toast/useToast";
import { ToastContainer } from "react-toastify";
import { useTranslations } from "next-intl";

function Form({ country }) {
  // =========== states =============
  const [countryList, setCountryList] = useState([]);
  const [formData, setFormData] = useState({});
  // errors
  const [errName, setErrName] = useState(null);
  const [errEmail, setErrEmail] = useState(null);
  const [errPhone, setErrPhone] = useState(null);
  const [shouldSubmit, setShouldSubmit] = useState(null);

  // =========== variables =============
  const t = useTranslations("contactUsPage");
  const showToast = useToast();
  const router = useRouter();

  // =========== useEffects =============
  // sort countries
  useEffect(() => {
    const temp = [];
    country.map((item) => {
      temp.push(router.locale == "ar" ? item.name_ar : item.name_en);
      temp.sort();
      setCountryList(temp);
    });
  }, [router.locale]);
  // form validation
  useEffect(() => {
    const { name, email, phone } = formData;
    const nameRegex = /[^a-zA-Z\u0600-\u06FF\s]/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    setErrName(() => nameRegex.test(name));
    setErrEmail(!emailRegex.test(email));
    setErrPhone(phone > 999999999999 || phone < 1000000);
  }, [formData.name, formData.email, formData.phone]);
  // check if should submit
  useEffect(() => {
    if (errEmail || errPhone || errName) {
      setShouldSubmit(false);
    } else {
      setShouldSubmit(true);
    }
  }, [errName, errEmail, errPhone]);

  // =========== functions =============
  const setDataFun = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const setCountry = (e) => {
    setFormData({ ...formData, country: e.value });
  };

  const handlSubmit = async (e) => {
    e.preventDefault();
    if (shouldSubmit) {
      try {
        await axios.post("user/email/send-email", {
          ...formData,
        });
        showToast("success", t("success"));
        setFormData({});
        e.target.reset();
      } catch (error) {
        showToast("error", t("error"));
      }
    } else {
      setErrEmail(errEmail ? "please enter a valid email" : null);
      setErrName(errName ? "please enter a valid name" : null);
      setErrPhone(errPhone ? "please enter a valid phone number" : null);
    }
  };

  return (
    <div className="mb-[54px] w-full">
      <ToastContainer />
      <form
        onSubmit={(e) => handlSubmit(e)}
        className=" grid grid-cols-12 gap-4 lg:gap-6  custom-breakpoint-1250"
      >
        {/* name  */}
        <div className="col-span-12 lg:col-span-6 space-y-[7px] relative">
          <label
            htmlFor="nameInput"
            className="text-[16px] flex items-center h-[19px] text-[#010140] mx-[2px] "
          >
            {t("name")}
          </label>
          <input
            type="text"
            name="name"
            autocomplete="off"
            id="nameInput"
            onBlur={(e) => setDataFun(e)}
            className="rounded-[8px] border-[1px] border-[#010140] border-opacity-20 h-12 w-full px-2"
            required
          />
          <div className="h-[11px] w-full  absolute bottom-[-11px] text-[#951B81] text-[9px] leading-[10.74px]">
            {errName}
          </div>
        </div>

        {/* email */}
        <div className="col-span-12 lg:col-span-6 space-y-[7px] relative">
          <label
            htmlFor="nameInput"
            className="text-[16px] flex items-center h-[19px] text-[#010140] mx-[2px] "
          >
            {t("email")}
          </label>
          <input
            type="email"
            name="email"
            id="emailInput"
            autocomplete="off"
            onBlur={(e) => setDataFun(e)}
            className="rounded-[8px] border-[1px] border-[#010140] border-opacity-20 h-12 w-full px-2"
            required
          />
          <div className="h-[11px] w-full  absolute bottom-[-11px] text-[#951B81] text-[9px] leading-[10.74px]">
            {errEmail}
          </div>
        </div>

        {/* phone  */}
        <div className="col-span-12 lg:col-span-6 space-y-[7px] relative">
          <label
            htmlFor="nameInput"
            className="text-[16px] flex items-center h-[19px] text-[#010140] mx-[2px] "
          >
            {t("phone")}
          </label>
          <input
            type="number"
            name="phone"
            id="emailInput"
            autocomplete="off"
            onBlur={(e) => setDataFun(e)}
            className="rounded-[8px] border-[1px] border-[#010140] border-opacity-20 h-12 w-full px-2"
          />
          <div className="h-[11px] w-full  absolute bottom-[-11px] text-[#951B81] text-[9px] leading-[10.74px]">
            {errPhone}
          </div>
        </div>

        {/* country  */}
        <div className=" relative col-span-12 lg:col-span-6 space-y-[7px] h-[75.8px] ">
          <label
            htmlFor="countrySelect"
            className="text-[16px] flex items-center h-[19px] text-[#010140] mx-[2px] "
          >
            {t("country")}
          </label>
          <div
            className="absolute bg-white  rounded-[8px] border-[1px] border-[#010140] border-opacity-20 min-h-[3rem] w-full"
            id="countrySelect"
          >
            <Dropdown
              options={countryList}
              className=" w-full h-full pl-2 "
              value={countryList[0]}
              arrowClosed={
                <span className=" w-fit mt-5 justify-end px-[14px]  h-fit top-0 flex  items-center right-0 upArrow">
                  <DownArrow />
                </span>
              }
              arrowOpen={
                <>
                  <span className=" w-fit mt-5   justify-start px-[14px]  h-fit top-0 flex items-center right-0 downArrow">
                    {" "}
                    <DownArrow />{" "}
                  </span>
                </>
              }
              onChange={(e) => setCountry(e)}
            />
          </div>
        </div>

        {/* message  */}
        <div className="col-span-12">
          <label
            htmlFor="message"
            className="text-[16px] flex items-center  h-[19px] mb-[7px] text-[#010140] ml-[2px] "
          >
            {t("message")}
          </label>

          <textarea
            cols="30"
            rows="5"
            name="message"
            onChange={(e) => setDataFun(e)}
            className="rounded-[8px] border-[1px] border-[#010140] border-opacity-20 w-full  p-2 "
            required
          ></textarea>
        </div>

        {/* send message  */}
        <button className="min-w-[15rem]">
          <CustomBtnComponent txt={t("send")} />
        </button>
      </form>
    </div>
  );
}

export default Form;
